import React from 'react';
import ReactMarkdown from 'react-markdown';

import Card from 'react-bootstrap/Card'

type CardHeaderProps = {
  /** The Markdown-formatted string to render. */
  children: string | null | undefined;
};

/**
 * Renders markdown content inside a Bootstrap Card.Header using react-markdown. When the value is empty, returns null.
 */
const CardHeader = ({children}: CardHeaderProps) => {
  if (!children) return null;

  return (
    <Card.Header className="text-center h3 pt-3 pb-0">
      <ReactMarkdown>{children}</ReactMarkdown>
    </Card.Header>
  );
}

export default CardHeader;